import LoadingDots from "../../UI/LoadingDots";
import Curl from "../../APIPlaygroundComponents/Curl";
import { memo, useMemo, useState } from "react";
import classes from "./ComplexityDescription.module.scss"
import { DDD, tx } from "../../../lib/ddd/ddd";
import {useEffect} from "react"
import fakeDDDIMinimalResponse from "../_fakeDDDIMinimalResponse.json";
import fakeUIMiminalResponse from "../_fakeUIMinimalResponse.json";
import { useQuery } from '@tanstack/react-query'
import Button from "../../UI/Button";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);

const complexityShortDescriptions = {
        "Minimal":
        "Suitable for light clients that can only generate classic invoices.",
        "Normal":
        `This is the default option and is suitable for all invoice types, including advances, credit notes, and others. Properties that are additional (not included in Minimal) are marked.`,
        "Maximal":
        "Supports the same invoice types as Normal, but includes all (rarely used) invoice data defined by the Peppol and UBL formats.",
}

export const ComplexityDescription = memo(function({complexity, connectionKey, normalInfo, maximalInfo, onTableArrayCreated, markComplexityDifferences, search}){
    const [isLoading, setIsLoading] = useState(true);
    const [DDDI_GetNewServer, setDDDI_GetNewServer] = useState();
    const [UI_GetNewServer, setUI_GetNewServer] = useState();
    const [curlCommand, setCurlCommand] = useState(null);
    const [validShows, setValidShows] =  useState({});

    const [tableFieldsArr, setTableFieldArr] = useState([]);
    const [tableDetailsArr, setDetailsArr] = useState([]);

    let DDDI_GetNewArguments = {
        Complexity : complexity
    }

    const {isPending : isMinimalPending, data : minimalData} = useQuery({
        queryKey: ['APP_GetNewDDDIAndUIMerged', "Minimal"],
        queryFn: () => ddd.APP_GetNewDDDIAndUIMerged({Complexity: "Minimal"}, {Complexity: "Minimal"}),
        enabled : !!markComplexityDifferences || complexity==="Minimal"
    })
    const {isPending : isNormalPending, data : normalData} = useQuery({
        queryKey: ['APP_GetNewDDDIAndUIMerged', "Normal"],
        queryFn: () => ddd.APP_GetNewDDDIAndUIMerged({Complexity: "Normal"}, {Complexity: "Normal"}),
        enabled : !!markComplexityDifferences || complexity==="Normal"
    })
    const {isPending : isMaximalPending, data : maximalData} = useQuery({
        queryKey: ['APP_GetNewDDDIAndUIMerged', "Maximal"],
        queryFn: () => ddd.APP_GetNewDDDIAndUIMerged({Complexity: "Maximal"}, {Complexity: "Maximal"}),
        enabled : !!markComplexityDifferences || complexity==="Maximal"
    })
    
    useEffect(()=>{
        let mainData = maximalData;
        let pending = isMaximalPending;

        if(complexity==="Minimal"){
            mainData = minimalData;
            pending = isMinimalPending
        }else if(complexity ==="Normal"){
            mainData = normalData;
            pending = isNormalPending
        }

        if(!pending)
            setIsLoading(false);

        if(mainData && mainData.DDDI_GetNew && mainData.UI_GetNew){
            let [mainTableArr, detailTableArr] = buildTablesArrayFromServerResponse(mainData.DDDI_GetNew, mainData.UI_GetNew);

            if(markComplexityDifferences && complexity === "Normal" && !isMinimalPending){
                let [minimalTableArr, minimalDetailArr] = buildTablesArrayFromServerResponse(mainData.DDDI_GetNew, mainData.UI_GetNew);
                mainTableArr.forEach(field => {
                    let index = minimalTableArr.findIndex(i => i.fieldName === field.fieldName);
                    if(!field.ui)
                        field.ui = {};
                    if(index < 0)
                        field.ui.notInMinimal = true;
                })
                detailTableArr.forEach(detailTable => {
                    let index = minimalDetailArr.findIndex(i => i.detail === detailTable.detail);
                    if(index<0){
                        detailTable.notInMinimal = true;
                    }else{
                        detailTable.fields.forEach(field => {
                            let findex = minimalDetailArr[index].fields.findIndex(i => i.fieldName === field.fieldName)
                            if(!field.ui)
                                field.ui = {};
                            if(findex < 0)
                                field.ui.notInMinimal = true;
                        })
                    }
                })
            }else if(markComplexityDifferences && complexity==="Maximal" && !isNormalPending){
                let [normalTableArr, normalDetailArr] = buildTablesArrayFromServerResponse(normalData.DDDI_GetNew, normalData.UI_GetNew);
                mainTableArr.forEach(field => {
                    let index = normalTableArr.findIndex(i => i.fieldName === field.fieldName);
                    if(!field.ui)
                        field.ui = {};
                    if(index < 0)
                        field.ui.notInMinimal = true;
                })
                detailTableArr.forEach(detailTable => {
                    let index = normalDetailArr.findIndex(i => i.detail === detailTable.detail);
                    if(index<0){
                        detailTable.notInMinimal = true;
                    }else{
                        detailTable.fields.forEach(field => {
                            let findex = normalDetailArr[index].fields.findIndex(i => i.fieldName === field.fieldName)
                            if(!field.ui)
                                field.ui = {};
                            if(findex < 0)
                                field.ui.notInMinimal = true;
                        })
                    }
                })
            }
            //console.log(mainTableArr);
            setTableFieldArr(mainTableArr);
            setDetailsArr(detailTableArr);
            if(onTableArrayCreated)
            onTableArrayCreated(complexity, mainTableArr, detailTableArr, mainData);
        }
    }, [isMinimalPending, minimalData, isNormalPending, normalData, isMaximalPending, maximalData, complexity]);

    useEffect(() =>{
       /*console.log(data);
        console.log(DDDI_GetNew);
        if(!DDDI_GetNew || !UI_GetNew)
            return;
        let ret = [];
        let {_details, ...main} = DDDI_GetNew;
        console.log(_details);
        console.log(main);
        for(let fieldName in main){
            let field = {};
            field.fieldName = fieldName;
            field.ui = null;
            if(UI_GetNew.hasOwnProperty(fieldName)){
                field.ui = UI_GetNew[fieldName]
            }
            ret.push(field);
        }
        let dret = [];
        for(let detail  in _details){
            if(!_details[detail] || _details[detail].length === 0)
                continue;
            let tmpd = {};
            tmpd.detail = detail;
            tmpd.fields = [];
            for(let fieldName  in _details[detail][0]){
                let field = {};
                field.fieldName = fieldName;
                if(UI_GetNew["_details"][detail] && UI_GetNew["_details"][detail].length > 0 && UI_GetNew["_details"][detail][0][fieldName])
                    field.ui = UI_GetNew["_details"][detail][0][fieldName];
                tmpd.fields.push(field);
            }
            dret.push(tmpd);
        }
        console.log(dret);

        setDetailsArr(dret);
        setTableFieldArr(ret);*/
    },[])

    useEffect(() => {
        const jsonString = JSON.stringify(DDDI_GetNewArguments);
        const curlCmd = tx(`curl -X POST https://${window.location.hostname}/api/service/EUeInvoices.DDDI_GetNew -H "Authorization: IoT ${connectionKey}:EUeInvoices" -H "Content-Type: application/json" -d ${JSON.stringify(jsonString)}`);
        setCurlCommand(curlCmd);
    }, [connectionKey])

    /**
     * 
     * @param {*} dddi DDDI_GetNew server response
     * @param {*} ui UI_GetNew response
     * @returns [[a],[b]]
     *  a:array = [{fieldName:string, ui:object},...]
     *  b:array = [{detail:string, fields:array = [{fieldName:string, ui:object},...]},...]
     */
    const buildTablesArrayFromServerResponse = (dddi, ui) =>{
        if(!dddi || !ui || !dddi.Invoice?.Invoice || !ui.Invoice)
            return [[],[]];

        let DDDI_GetNew = dddi.Invoice?.Invoice;
        let UI_GetNew = ui.Invoice;
        let ret = [];
        let {_details, ...main} = DDDI_GetNew;
        for(let fieldName in main){
            let field = {};
            field.fieldName = fieldName;
            field.ui = null;
            if(UI_GetNew.hasOwnProperty(fieldName)){
                field.ui = UI_GetNew[fieldName]
            }
            ret.push(field);
        }
        let dret = [];
        for(let detail  in _details){
            if(!_details[detail] || _details[detail].length === 0)
                continue;
            let tmpd = {};
            tmpd.detail = detail;
            tmpd.fields = [];
            for(let fieldName  in _details[detail][0]){
                let field = {};
                field.fieldName = fieldName;
                if(UI_GetNew["_details"][detail] && UI_GetNew["_details"][detail].length > 0 && UI_GetNew["_details"][detail][0][fieldName])
                    field.ui = UI_GetNew["_details"][detail][0][fieldName];
                tmpd.fields.push(field);
            }
            dret.push(tmpd);
        }
        return [ret, dret];
    }

    const onValidClick = (fieldName) =>  {
        setValidShows({...validShows, [fieldName]:!validShows[fieldName]});
    }

    useEffect(()=>{
        /*if(!DDDI_GetNew || !UI_GetNew){
            //TODO: replace fake with real below
            setDDDI_GetNewServer(fakeDDDIMinimalResponse);
            setUI_GetNewServer(fakeUIMiminalResponse);
            setDDDI_GetNew(fakeDDDIMinimalResponse.result?.Result?.Invoice?.Invoice);
            setUI_GetNew(fakeUIMiminalResponse.result?.Result?.Invoice);
            console.log(fakeDDDIMinimalResponse);
            console.log(fakeUIMiminalResponse);
 
            setIsLoading(false);
            return;

            setIsLoading(true);
            ddd.APP_GetNewDDDIAndUIMerged(DDDI_GetNewArguments, UI_GetNewArguments).then((res) =>{
                setIsLoading(false);
                if(!res || !res.DDDI_GetNew || !res.UI_GetNew)
                    return;
                setDDDI_GetNewServer(res.DDDI_GetNew);
                setUI_GetNewServer(res.UI_GetNew);
                setDDDI_GetNew(res.DDDI_GetNew.Invoice?.Invoice);
                setUI_GetNew(res.UI_GetNew.Invoice);
            })
        }*/
    }, [])
     
    return(
        <>
        {isLoading && <LoadingDots/>}
        {!isLoading &&
        <>
            <p>{complexityShortDescriptions[complexity]}</p>
            <p style={{textAlign:"center", fontSize:"1.3rem"}}>Sent request:</p>
            <Curl
            currentCurl={curlCommand}
            currentJson={DDDI_GetNewArguments}
            activeApi="DDDI_GetNew"
            />

        <p>Fields:</p>
        {(complexity==="Normal" || complexity==="Maximal") && 
            <p className={classes["normalRowDescription"]}>
                <i className={`ti-help`}></i>
                New fields are marked by a by this color
            </p> 
        } 
        <table className="table table-sm">
            <thead>
                <tr>
                    <th scope="col"></th>
                    <th scope="col">Name</th>
                    <th scope="col">Type</th>
                    <th scope="col">Description</th>
                    <th scope="col">Required</th>
                </tr>
            </thead>
            <tbody>
                {tableFieldsArr.map(({fieldName, ui}) => {
                    if(search && search.trim().length > 0 && fieldName.toLowerCase().indexOf(search.toLowerCase()) < 0)
                        return;
                    return (<>
                        <tr className={ui?.notInMinimal ? classes["normalRow"] : ""}>
                            <td>{/* {ui.ValidValues ? 
                                <><Button onClick={() =>{setValidShows({...validShows, [fieldName]:!validShows[fieldName]})}}>
                                    {validShows[fieldName] ? <KeyboardArrowDownIcon/> : <KeyboardArrowRightIcon/>}
                                </Button></> : <></>
                            } */}
                            {ui?.ValidValues && <>
                                {validShows[fieldName] ? <KeyboardArrowDownIcon style={{cursor:"pointer"}} onClick={() => onValidClick(fieldName)}/> : <KeyboardArrowRightIcon style={{cursor:"pointer"}} onClick={() => onValidClick(fieldName)}/>}
                            </>}
                            </td>
                            <th scope="row">{fieldName}</th>
                            <td>{ui?.Type}</td>
                            <td>{ui?.Trans?.Tooltip || ui?.Trans?.Title}</td>
                            <td style={{textAlign:"center"}}>{ui?.Mandatory ? 
                                <span><i className="ti-check" /></span>
                                 : 
                                <span><i className="ti-minus" /></span>
                                }</td>
                        </tr>
                        {ui?.ValidValues && validShows[fieldName] && 
                            <tr style={{width:"100%"}}>
                                <td colspan="100%">
                                    <div>Value set:</div>
                                    
                                    <div className={`d-flex p-2 w-100 ${classes["valid-values"]}`} >
                                    <ul>
                                        {ui?.ValidValues.map((val, i) =>{
                                            return(<><li><span style={{fontWeight:"700"}}>{val.Code}</span> ({val.UI})</li></>)
                                        })}
                                    </ul>
                                    </div>
                                </td>
                            </tr>}
                    </>)
                })}
            </tbody>
        </table>
        <p>Details:</p>
        {tableDetailsArr.map(({detail, fields, notInMinimal}) => {
            return (
            <>
            <p className={classes["detailTableTitle"]}>{detail}</p>
            <table className="table table-sm">
                <thead>
                    <tr>
                        <th scope="col"></th>
                        <th scope="col">Name</th>
                        <th scope="col">Type</th>
                        <th scope="col">Description</th>
                        <th scope="col">Required</th>
                    </tr>
                </thead>
                <tbody className={notInMinimal ? classes["normalRow"] : ""}>
                    {fields.map(({fieldName, ui}) => {
                        if(search && search.trim().length > 0 && fieldName.toLowerCase().indexOf(search.toLowerCase()) < 0)
                            return;
                        return (<>
                            <tr className={ui?.notInMinimal ? classes["normalRow"] : ""}>
                                <td>
                                    {ui?.ValidValues && <>
                                        {validShows[fieldName] ? <KeyboardArrowDownIcon style={{cursor:"pointer"}} onClick={() => onValidClick(fieldName)}/> : <KeyboardArrowRightIcon style={{cursor:"pointer"}} onClick={() => onValidClick(fieldName)}/>}
                                    </>}
                                </td>
                                <th scope="row">{fieldName}</th>
                                <td>{ui?.Type}</td>
                                <td>{ui?.Trans?.Tooltip || ui?.Trans?.Title}</td>
                                <td style={{textAlign:"center"}}>{ui?.Mandatory ? 
                                    <span><i className="ti-check" /></span>
                                    : 
                                    <span><i className="ti-minus" /></span>
                                    }</td>
                            </tr>
                            {ui?.ValidValues && validShows[fieldName] && 
                            <tr style={{width:"100%"}}>
                                <td colspan="100%">
                                    <div>Value set:</div>
                                    
                                    <div className={`d-flex p-2 w-100 ${classes["valid-values"]}`} >
                                    <ul>
                                        {ui?.ValidValues.map((val, i) =>{
                                            return(<><li><span style={{fontWeight:"700"}}>{val.Code}</span> ({val.UI})</li></>)
                                        })}
                                    </ul>
                                    </div>
                                </td>
                            </tr>}
                        </>)
                    })}
                </tbody>
            </table>
            </>)
        })}
        </>
        }
        </>
    )
});